export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/constants.js
// module id = 658
// module chunks = 0